import { createFileRoute } from "@tanstack/react-router"
import { projectSettingsMembersViewStaticData } from "src/views/ProjectSettingsMembersView/constants"
import { ProjectSettingsMembersView } from "src/views/ProjectSettingsMembersView/ProjectSettingsMembersView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/members")({
	component: ProjectSettingsMembersView,
	staticData: projectSettingsMembersViewStaticData,
})
